document.addEventListener("DOMContentLoaded", initScrollTextReveal);
document.addEventListener("shopify:section:load", initScrollTextReveal);

function initScrollTextReveal() {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;

  gsap.registerPlugin(ScrollTrigger);

  document.querySelectorAll("[data-scroll-reveal] .scroll-reveal-text").forEach(textEl => {
    if (textEl.dataset.processed) return;
    textEl.dataset.processed = true;

    const words = textEl.innerText.trim().split(" ");
    textEl.innerHTML = words.map(word => `<span>${word}&nbsp;</span>`).join("");

    gsap.fromTo(
      textEl.querySelectorAll("span"),
      { opacity: 0.2 },
      {
        opacity: 1,
        stagger: 0.2,
        scrollTrigger: {
          trigger: textEl,
          start: "top center",   // Adjusted for no margin
          end: "bottom center",  // Ends when last word reaches center
          scrub: true
        }
      }
    );
  });
}
